import { render, staticRenderFns } from "./TextEditorImageSelector.vue?vue&type=template&id=875d08b2"
import script from "./TextEditorImageSelector.vue?vue&type=script&lang=js"
export * from "./TextEditorImageSelector.vue?vue&type=script&lang=js"
import style0 from "./TextEditorImageSelector.vue?vue&type=style&index=0&id=875d08b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports